import React from 'react';
import { withRouter } from 'react-router-dom'
import { Calendar, Badge } from 'antd';
import axios from "axios";
import './style.css';
import moment from 'moment';
import { withTranslation } from 'react-i18next';



class EventCalendar extends React.Component {
    state = {
        data: [],
        loading: true,
    }

    componentWillMount() {
        let token = localStorage.getItem('token');
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
        axios.defaults.headers = {
            "Content-Type": "application/json",
            "Accept-Language": localStorage.getItem('language'),
            Authorization: `Token ${token}`,
        };
        this.fetch();
    };

    fetch = (params = {}) => {
        this.setState({ loading: true });
        axios({
            url: process.env.REACT_APP_AXIOS_URL + "/api/events/",
            method: 'get',
            params: {
                search: params.search,
                filter: params.filter
            },
        }).then(res => {
            this.setState({
                loading: false,
                data: res.data.results,
            });
        });
    };

    getListData = (value) => {
        let listData = this.state.data;
        let listDataFiltered = [];
        if (listData)
            listDataFiltered = listData.filter(event => {
                return event.start_date == value.format("YYYY-MM-DD").toString();
            });
        // if (listDataFiltered.length) {
        //     listDataFiltered = this.changeListData(listDataFiltered);
        // }
        //         listData = [
        //             { type: 'warning', content: 'This is warning event' },
        //             { type: 'success', content: 'This is very long usual event。。....' },
        //             { type: 'error', content: 'This is error event 1.' },
        //         ];
        return listDataFiltered || [];
    }

    // changeListData = (value) => {
    //     let changedValue = value.map(item => {
    //         if (item.event_type === "Meeting")
    //             item.type = 'error';
    //         if (item.event_type === "Call")
    //             item.type = 'warning';
    //         // if (item.event_type === "Low")
    //         //     item.type = 'success';
    //         return item;
    //     });
    //     return changedValue;
    // }

    dateCellRender = (value) => {
        const listData = this.getListData(value);
        return (
            <ul className="events">
                {listData.map(item => (
                    <li key={item.id}>
                        <Badge status='success' text={item.name} />
                        {/* <Badge status={item.type} text={item.name} />  */}
                    </li>
                ))}
            </ul>
        );
    }

    render() {
        return (
            <div>
                <Calendar
                    dateCellRender={this.dateCellRender}
                    locale={moment.locale(localStorage.getItem('language'))}
                />
            </div>
        )
    }
}

export default withRouter(withTranslation()(EventCalendar));



// WEBPACK FOOTER //
// ./src/containers/Events/EventCalendar.js